module.exports = __webpack_public_path__ + "img/green_068.925a545d.png";